import { Component, Input, Output} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { SearchSorting } from '../../../../modules/tcm-core.module';

@Component({
    selector: '[table-header]',
    templateUrl: 'table-header.component.html',
    styleUrls: ['table-header.component.scss'],
    standalone: false
})
export class TableHeaderComponent {
    @Input() public key: string;
    @Input() public label: string;
    @Input() public sortable: boolean;
    @Input() public sortModel: SearchSorting;
    @Input() public isRequired: boolean;
    
    @Output() public sort = new EventEmitter();
   
    public onSortingChange(){
        if(this.sortModel){
            if(this.sortModel.column == this.key){
                this.sortModel.isDescending = !this.sortModel.isDescending;
            }
            else{
                this.sortModel.column = this.key;
                this.sortModel.isDescending = false;
            }

            this.sort.emit(null);
        }
    }
}